








































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Container from '../../Registration/v2/Container.vue';
import RegistrationCard from '../../Registration/v2/Card.vue';
import CardHeader from '../../Registration/v2/Header.vue';
import { AuthParams } from '@/models/userdata/authparams';
import { OAuthPassport } from '@/models/userdata/socialauthparams';
import { vxm } from '@/store.vuex';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class Login extends Vue {
  @Prop() sessionExpired;
  private showPassword = false;
  private isEmailPresent: boolean = false;

  private emailRegex: RegExp = vxm.utility.emailRegex;
  private authParams: AuthParams = new AuthParams();
  private errorString: string = '';
  private isMobileScreen: boolean = false;
  $wlToastr: any;
  private rememberMe: boolean = this.$cookies.get('rememberMe') === 'true';
  private errors = {
    username: '',
    password: '',
  };

  get companyName(): String {
    return vxm.utility.companyName;
  }
  setShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onCancel() {
    if (vxm.utility.UserDeviceToken) {
      const appurl = '/atsuser/regSuccess?success=false';
      (<any>window).location = appurl;
      return;
    }
    this.$router.push({ name: 'Findjobs' });
  }

  setRememberMe(value) {
    this.rememberMe = value;
    this.$cookies.set('rememberMe', value);
  }

  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }
  onLogin() {
    this.authParams.companyCode = this.$store.state.jobs.companyCode;
    if (this.validateLoginData(this.authParams)) {
      if (this.rememberMe) {
        this.$cookies.set('userName', this.authParams.username, Infinity);
        this.$cookies.set('rememberMe', this.rememberMe, Infinity);
        this.$cookies.set('password', this.authParams.password, Infinity);
      } else {
        this.$cookies.remove('userName');
        this.$cookies.remove('rememberMe');
        this.$cookies.remove('password');
      }

      const respPromise = vxm.users.login(this.authParams).then(async (value) => {
        if (value === false) {
          let errorMessageText =
            vxm.users.getErrorMesaageLogin !== ''
              ? vxm.users.getErrorMesaageLogin
              : 'login.failure.incorrect.password';
          const v1FailureMessage = this.$t(
            'login.failure.invalid.password.v1.msg',
          );

          if (
            errorMessageText ===
            'Your account has been locked. To unlock your account, please reset your password using Forgot Password.'
          ) {
            this.$cookies.set('userName', this.authParams.username);
            this.$router.push({ name: 'AccountLocked' });
          } else {
            if (errorMessageText === v1FailureMessage) {
              errorMessageText = 'login.failure.invalid.password.v2.msg';
            }
            this.errors = {
              username: '',
              password: errorMessageText,
            };
          }
        } else if (value && !vxm.users.EmailVerified) {
          let payload = {
            companyCode: vxm.jobs.BrandingInfo.companycode,
            userEmail: this.authParams.username,
          };
          vxm.users.sendOtpCode(payload);
          this.$router.push({ name: 'OTPLogin' });
        }
        else if(value == true){
          let payload = {
      companyCode: vxm.jobs.BrandingInfo.companycode,
      userEmail: this.authParams.username,
    };
          vxm.users.Rudderstack.trackEvent("User Loggedin", {});

    if (vxm.configs.getGlobalConfigBooelanValue('WL_MULTI_FACTOR_AUTHENTICATION_ENABLED')) {
      const response = await vxm.users.sendOtpCode(payload);
      if (response.data.success === true) {
      this.$router.push({ name: 'OTPLogin' });
      this.$wlToastr(
        'success',
        this.$t('otp-login.toast.codesentmessage'),
        this.$t('otp-login.toast.title'),
      );
            }
            else {
      const errorMessage = response.data.error;
      this.$wlToastr('error', errorMessage, this.$t('otp-login.toast.title'));
    }
        }
      }
      });
    }
  }

  validateLoginData(authParams: AuthParams): boolean {
    let formValid = true;
    this.errors = {
      username: '',
      password: '',
    };
    if (!this.emailRegex.test(authParams.username)) {
      this.errors.username = 'login.email.invalid';
    }

    if (!authParams.username) {
      this.errors.username = 'login.email.required';
    }

    if (!authParams.password) {
      this.errors.password = 'login.password.required';
    }

    Object.keys(this.errors).forEach((field) => {
      formValid = formValid && !this.errors[field];
    });
    return formValid;
  }

  mounted() {
    this.isMobileScreen = vxm.utility.isMobileDevice;
    if (this.sessionExpired) {
      this.$wlToastr(
        'info',
        'Your session has timed out. Please sign in again.',
        'Session Timeout',
      );
    }

    this.authParams.username = vxm.users.UserParams.email;
    this.authParams.password = this.$cookies.get('password');

    this.isEmailPresent =
      null != this.authParams.username && '' !== this.authParams.username;
    console.log('href', window.location.href);

    if (window.location.href.indexOf('?') >= 0)
      window.location.href
        .split('?')[1]
        .split('&')
        .forEach((elm) => {
          if (elm.indexOf('code') >= 0) {
            const token = elm.split('=')[1];
            console.log('token ', token);
            console.log('token', decodeURI(token));
            const ccode = decodeURI(token.replace('%2F', '/').replace('=', ''));
            console.log('this.getOAuthProvider()');
            console.log(this.getOAuthProvider());
            if (this.getOAuthProvider() === 'apple') {
              const oauthPassport = new OAuthPassport();
              oauthPassport.email = String(this.$route.query.email);
              oauthPassport.oAuthToken = String(ccode);
              oauthPassport.oAuthProvider = 'apple';
              vxm.users.socialLogin(oauthPassport);
            }

            if (this.getOAuthProvider() === 'facebook') {
              vxm.users.validateFacebookOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'google') {
              vxm.users.validateGoogleOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'linkedin') {
              vxm.users.validateLinkedinOAuthCode(ccode);
            }

            if (!this.getOAuthProvider()) {
              this.$router.push('login');
            }
          }
        });
  }

  goBack() {
    this.$router.push({ name: 'LoginUniversalEntryPoint' });
  }
  goToForgotPassword() {
    this.$cookies.set('userName', this.authParams.username);
    this.$router.push({ name: 'ForgotPasswordForm' });
  }

  async sendOtpCode() {
    let payload = {
      companyCode: vxm.jobs.BrandingInfo.companycode,
      userEmail: this.authParams.username,
    };

    const response = await vxm.users.sendOtpCode(payload);

    if (response.data.success === true) {
      vxm.users.setRouterAfterOTPForm(vxm.users.getDefaultRouterAfterOTPForm);
      this.$wlToastr(
        'success',
        this.$t('otp-login.toast.codesentmessage'),
        this.$t('otp-login.toast.title'),
      );
      this.$router.push({
        name: 'OTPLogin',
        params: { username: this.authParams.username },
      });
    } else {
      this.$wlToastr(
        'error',
        response.data.error,
        this.$t('otp-login.toast.title'),
      );
    }
  }
}
